import * as t from 'io-ts';

export const PriceClassSchema = t.keyof({
    CONTRACTUAL: null,
    NON_CONTRACTUAL: null,
});

export type PriceClass = t.TypeOf<typeof PriceClassSchema>;
